/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BadRequestErrorResponse,
    BadRequestErrorResponseFromJSON,
    BadRequestErrorResponseToJSON,
    ConflictErrorResponse,
    ConflictErrorResponseFromJSON,
    ConflictErrorResponseToJSON,
    ConnectionStatus,
    ConnectionStatusFromJSON,
    ConnectionStatusToJSON,
    DeviceRequest,
    DeviceRequestFromJSON,
    DeviceRequestToJSON,
    DeviceResponse,
    DeviceResponseFromJSON,
    DeviceResponseToJSON,
    DeviceStatus,
    DeviceStatusFromJSON,
    DeviceStatusToJSON,
    DevicesResponse,
    DevicesResponseFromJSON,
    DevicesResponseToJSON,
    NewResourceResponse,
    NewResourceResponseFromJSON,
    NewResourceResponseToJSON,
    NotFoundErrorResponse,
    NotFoundErrorResponseFromJSON,
    NotFoundErrorResponseToJSON,
    TagEnum,
    TagEnumFromJSON,
    TagEnumToJSON,
} from '../models';

export interface CreateDeviceExportJobRequest {
    filterMacAddress?: string | null;
    filterSerialNumber?: string | null;
    filterDeviceTypeId?: Array<string> | null;
    filterStbGroupId?: Array<string> | null;
    filterComments?: Array<string> | null;
    filterIsTraceEnabled?: boolean | null;
    filterIsLightReset?: boolean | null;
    filterIsFullReset?: boolean | null;
    filterIsMoveToPreproduction?: boolean | null;
    filterIsLogHistory?: boolean | null;
    filterLoaderVersion?: Array<string> | null;
    filterFirmwareVersion?: Array<string> | null;
    filterUiVersion?: Array<string> | null;
    filterCustomFirmware1?: Array<string> | null;
    filterCustomFirmware2?: Array<string> | null;
    filterCustomFirmware3?: Array<string> | null;
    filterConnectionStatus?: ConnectionStatus;
    filterDuration?: string | null;
    filterDeviceStatus?: Array<DeviceStatus> | null;
    notConnectedSince?: Date | null;
    filterTags?: Array<TagEnum> | null;
}

export interface DeleteDeviceRequest {
    id: string;
}

export interface ReadDeviceRequest {
    id: string;
}

export interface ReadDevicesRequest {
    filterMacAddress?: string | null;
    filterSerialNumber?: string | null;
    filterDeviceTypeId?: Array<string> | null;
    filterStbGroupId?: Array<string> | null;
    filterComments?: Array<string> | null;
    filterIsTraceEnabled?: boolean | null;
    filterIsLightReset?: boolean | null;
    filterIsFullReset?: boolean | null;
    filterIsMoveToPreproduction?: boolean | null;
    filterIsLogHistory?: boolean | null;
    filterLoaderVersion?: Array<string> | null;
    filterFirmwareVersion?: Array<string> | null;
    filterUiVersion?: Array<string> | null;
    filterCustomFirmware1?: Array<string> | null;
    filterCustomFirmware2?: Array<string> | null;
    filterCustomFirmware3?: Array<string> | null;
    filterConnectionStatus?: ConnectionStatus;
    filterDuration?: string | null;
    filterDeviceStatus?: Array<DeviceStatus> | null;
    notConnectedSince?: Date | null;
    filterTags?: Array<TagEnum> | null;
    offset?: number | null;
    limit?: number | null;
    orderBy?: string | null;
    direction?: ReadDevicesDirectionEnum;
}

export interface ReinitializeTryCounterRequest {
    id: string;
}

export interface UpdateDeviceRequest {
    id: string;
    deviceRequest: DeviceRequest;
}

/**
 * 
 */
export class DevicesApi extends runtime.BaseAPI {

    /**
     * Create device export job.
     */
    async createDeviceExportJobRaw(requestParameters: CreateDeviceExportJobRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NewResourceResponse>> {
        const queryParameters: any = {};

        if (requestParameters.filterMacAddress !== undefined) {
            queryParameters['filterMacAddress'] = requestParameters.filterMacAddress;
        }

        if (requestParameters.filterSerialNumber !== undefined) {
            queryParameters['filterSerialNumber'] = requestParameters.filterSerialNumber;
        }

        if (requestParameters.filterDeviceTypeId) {
            queryParameters['filterDeviceTypeId'] = requestParameters.filterDeviceTypeId;
        }

        if (requestParameters.filterStbGroupId) {
            queryParameters['filterStbGroupId'] = requestParameters.filterStbGroupId;
        }

        if (requestParameters.filterComments) {
            queryParameters['filterComments'] = requestParameters.filterComments;
        }

        if (requestParameters.filterIsTraceEnabled !== undefined) {
            queryParameters['filterIsTraceEnabled'] = requestParameters.filterIsTraceEnabled;
        }

        if (requestParameters.filterIsLightReset !== undefined) {
            queryParameters['filterIsLightReset'] = requestParameters.filterIsLightReset;
        }

        if (requestParameters.filterIsFullReset !== undefined) {
            queryParameters['filterIsFullReset'] = requestParameters.filterIsFullReset;
        }

        if (requestParameters.filterIsMoveToPreproduction !== undefined) {
            queryParameters['filterIsMoveToPreproduction'] = requestParameters.filterIsMoveToPreproduction;
        }

        if (requestParameters.filterIsLogHistory !== undefined) {
            queryParameters['filterIsLogHistory'] = requestParameters.filterIsLogHistory;
        }

        if (requestParameters.filterLoaderVersion) {
            queryParameters['filterLoaderVersion'] = requestParameters.filterLoaderVersion;
        }

        if (requestParameters.filterFirmwareVersion) {
            queryParameters['filterFirmwareVersion'] = requestParameters.filterFirmwareVersion;
        }

        if (requestParameters.filterUiVersion) {
            queryParameters['filterUiVersion'] = requestParameters.filterUiVersion;
        }

        if (requestParameters.filterCustomFirmware1) {
            queryParameters['filterCustomFirmware1'] = requestParameters.filterCustomFirmware1;
        }

        if (requestParameters.filterCustomFirmware2) {
            queryParameters['filterCustomFirmware2'] = requestParameters.filterCustomFirmware2;
        }

        if (requestParameters.filterCustomFirmware3) {
            queryParameters['filterCustomFirmware3'] = requestParameters.filterCustomFirmware3;
        }

        if (requestParameters.filterConnectionStatus !== undefined) {
            queryParameters['filterConnectionStatus'] = requestParameters.filterConnectionStatus;
        }

        if (requestParameters.filterDuration !== undefined) {
            queryParameters['filterDuration'] = requestParameters.filterDuration;
        }

        if (requestParameters.filterDeviceStatus) {
            queryParameters['filterDeviceStatus'] = requestParameters.filterDeviceStatus;
        }

        if (requestParameters.notConnectedSince !== undefined) {
            queryParameters['notConnectedSince'] = (requestParameters.notConnectedSince as any).toISOString();
        }

        if (requestParameters.filterTags) {
            queryParameters['filterTags'] = requestParameters.filterTags;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jobExports/devices`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NewResourceResponseFromJSON(jsonValue));
    }

    /**
     * Create device export job.
     */
    async createDeviceExportJob(requestParameters: CreateDeviceExportJobRequest = {}, initOverrides?: RequestInit): Promise<NewResourceResponse> {
        const response = await this.createDeviceExportJobRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete device by ID.
     */
    async deleteDeviceRaw(requestParameters: DeleteDeviceRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteDevice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/devices/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete device by ID.
     */
    async deleteDevice(requestParameters: DeleteDeviceRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteDeviceRaw(requestParameters, initOverrides);
    }

    /**
     * Read all comment of devices.
     */
    async readAllCommentsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/devices/allComments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Read all comment of devices.
     */
    async readAllComments(initOverrides?: RequestInit): Promise<Array<string>> {
        const response = await this.readAllCommentsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Read device by ID.
     */
    async readDeviceRaw(requestParameters: ReadDeviceRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DeviceResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling readDevice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/devices/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeviceResponseFromJSON(jsonValue));
    }

    /**
     * Read device by ID.
     */
    async readDevice(requestParameters: ReadDeviceRequest, initOverrides?: RequestInit): Promise<DeviceResponse> {
        const response = await this.readDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read supported CUSTOFW1 versions for devices.
     */
    async readDeviceCustofw1VersionsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/devices/custofw1Versions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Read supported CUSTOFW1 versions for devices.
     */
    async readDeviceCustofw1Versions(initOverrides?: RequestInit): Promise<Array<string>> {
        const response = await this.readDeviceCustofw1VersionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Read supported CUSTOFW2 versions for devices.
     */
    async readDeviceCustofw2VersionsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/devices/custofw2Versions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Read supported CUSTOFW2 versions for devices.
     */
    async readDeviceCustofw2Versions(initOverrides?: RequestInit): Promise<Array<string>> {
        const response = await this.readDeviceCustofw2VersionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Read supported CUSTOFW3 versions for devices.
     */
    async readDeviceCustofw3VersionsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/devices/custofw3Versions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Read supported CUSTOFW3 versions for devices.
     */
    async readDeviceCustofw3Versions(initOverrides?: RequestInit): Promise<Array<string>> {
        const response = await this.readDeviceCustofw3VersionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Read supported FW versions for devices.
     */
    async readDeviceFwVersionsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/devices/fwVersions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Read supported FW versions for devices.
     */
    async readDeviceFwVersions(initOverrides?: RequestInit): Promise<Array<string>> {
        const response = await this.readDeviceFwVersionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Read supported LOADER versions for devices.
     */
    async readDeviceLoaderVersionsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/devices/loaderVersions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Read supported LOADER versions for devices.
     */
    async readDeviceLoaderVersions(initOverrides?: RequestInit): Promise<Array<string>> {
        const response = await this.readDeviceLoaderVersionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Read supported UI versions for devices.
     */
    async readDeviceUiVersionsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/devices/uiVersions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Read supported UI versions for devices.
     */
    async readDeviceUiVersions(initOverrides?: RequestInit): Promise<Array<string>> {
        const response = await this.readDeviceUiVersionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Read devices.
     */
    async readDevicesRaw(requestParameters: ReadDevicesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DevicesResponse>> {
        const queryParameters: any = {};

        if (requestParameters.filterMacAddress !== undefined) {
            queryParameters['filterMacAddress'] = requestParameters.filterMacAddress;
        }

        if (requestParameters.filterSerialNumber !== undefined) {
            queryParameters['filterSerialNumber'] = requestParameters.filterSerialNumber;
        }

        if (requestParameters.filterDeviceTypeId) {
            queryParameters['filterDeviceTypeId'] = requestParameters.filterDeviceTypeId;
        }

        if (requestParameters.filterStbGroupId) {
            queryParameters['filterStbGroupId'] = requestParameters.filterStbGroupId;
        }

        if (requestParameters.filterComments) {
            queryParameters['filterComments'] = requestParameters.filterComments;
        }

        if (requestParameters.filterIsTraceEnabled !== undefined) {
            queryParameters['filterIsTraceEnabled'] = requestParameters.filterIsTraceEnabled;
        }

        if (requestParameters.filterIsLightReset !== undefined) {
            queryParameters['filterIsLightReset'] = requestParameters.filterIsLightReset;
        }

        if (requestParameters.filterIsFullReset !== undefined) {
            queryParameters['filterIsFullReset'] = requestParameters.filterIsFullReset;
        }

        if (requestParameters.filterIsMoveToPreproduction !== undefined) {
            queryParameters['filterIsMoveToPreproduction'] = requestParameters.filterIsMoveToPreproduction;
        }

        if (requestParameters.filterIsLogHistory !== undefined) {
            queryParameters['filterIsLogHistory'] = requestParameters.filterIsLogHistory;
        }

        if (requestParameters.filterLoaderVersion) {
            queryParameters['filterLoaderVersion'] = requestParameters.filterLoaderVersion;
        }

        if (requestParameters.filterFirmwareVersion) {
            queryParameters['filterFirmwareVersion'] = requestParameters.filterFirmwareVersion;
        }

        if (requestParameters.filterUiVersion) {
            queryParameters['filterUiVersion'] = requestParameters.filterUiVersion;
        }

        if (requestParameters.filterCustomFirmware1) {
            queryParameters['filterCustomFirmware1'] = requestParameters.filterCustomFirmware1;
        }

        if (requestParameters.filterCustomFirmware2) {
            queryParameters['filterCustomFirmware2'] = requestParameters.filterCustomFirmware2;
        }

        if (requestParameters.filterCustomFirmware3) {
            queryParameters['filterCustomFirmware3'] = requestParameters.filterCustomFirmware3;
        }

        if (requestParameters.filterConnectionStatus !== undefined) {
            queryParameters['filterConnectionStatus'] = requestParameters.filterConnectionStatus;
        }

        if (requestParameters.filterDuration !== undefined) {
            queryParameters['filterDuration'] = requestParameters.filterDuration;
        }

        if (requestParameters.filterDeviceStatus) {
            queryParameters['filterDeviceStatus'] = requestParameters.filterDeviceStatus;
        }

        if (requestParameters.notConnectedSince !== undefined) {
            queryParameters['notConnectedSince'] = (requestParameters.notConnectedSince as any).toISOString();
        }

        if (requestParameters.filterTags) {
            queryParameters['filterTags'] = requestParameters.filterTags;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.direction !== undefined) {
            queryParameters['direction'] = requestParameters.direction;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/devices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevicesResponseFromJSON(jsonValue));
    }

    /**
     * Read devices.
     */
    async readDevices(requestParameters: ReadDevicesRequest = {}, initOverrides?: RequestInit): Promise<DevicesResponse> {
        const response = await this.readDevicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reinitialize try counter.
     */
    async reinitializeTryCounterRaw(requestParameters: ReinitializeTryCounterRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling reinitializeTryCounter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/devices/{id}/tryCounter`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reinitialize try counter.
     */
    async reinitializeTryCounter(requestParameters: ReinitializeTryCounterRequest, initOverrides?: RequestInit): Promise<void> {
        await this.reinitializeTryCounterRaw(requestParameters, initOverrides);
    }

    /**
     * Update device by ID.
     */
    async updateDeviceRaw(requestParameters: UpdateDeviceRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateDevice.');
        }

        if (requestParameters.deviceRequest === null || requestParameters.deviceRequest === undefined) {
            throw new runtime.RequiredError('deviceRequest','Required parameter requestParameters.deviceRequest was null or undefined when calling updateDevice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/devices/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DeviceRequestToJSON(requestParameters.deviceRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update device by ID.
     */
    async updateDevice(requestParameters: UpdateDeviceRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateDeviceRaw(requestParameters, initOverrides);
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ReadDevicesDirectionEnum {
    Asc = 'ASC',
    Desc = 'DESC'
}
